export const MID_TERRAIN_LENGTH_DEFAULT = 500;
export const MID_TERRAIN_LENGTH_MIN = 100;
export const MID_TERRAIN_LENGTH_MAX = 5000;
export const MID_TERRAIN_RESOLUTION_MARKS = [5, 10, 15, 20, 25].map((value) => ({ value, label: `${value}m` }));

export const FAR_TERRAIN_LENGTH_DEFAULT = 5000;
export const FAR_TERRAIN_LENGTH_MIN = 100;
export const FAR_TERRAIN_RESOLUTION_MIN = 30;
export const FAR_TERRAIN_RESOLUTION_MAX = 450;
export const FAR_TERRAIN_RESOLUTION_MARKS = [30, 90, 180, 270, 360, 450].map((value) => ({
  value,
  label: `${value}`,
}));
export const FAR_TERRAIN_LENGTH_MAX_AT_MIN_RESOLUTION = 15000;
export const FAR_TERRAIN_LENGTH_MAX_AT_MAX_RESOLUTION = 80000;

export const TREES_EXTERNAL_RADIUS_DEFAULT = 200;
export const TREES_EXTERNAL_RADIUS_MIN = 50;
export const TREES_EXTERNAL_RADIUS_MAX = 1500;
export const TREES_INTERNAL_RADIUS_DEFAULT = 0;
export const TREES_INTERNAL_RADIUS_MIN = 0;
export const TREES_MINIMAL_HEIGHT_DEFAULT = 3;
export const TREES_MINIMAL_HEIGHT_MIN = 1;
export const TREES_MINIMAL_HEIGHT_MAX = 50;
export const TREES_CONCAVE_ALPHA_DEFAULT = 2;
export const TREES_CONCAVE_ALPHA_MIN = 0;
export const TREES_CONCAVE_ALPHA_MAX = 100;
export const TREES_RADIUS_VALIDATION_MIN = 0;
export const TREES_RADIUS_VALIDATION_MAX = 5000;
export const TREES_MINIMAL_HEIGHT_VALIDATION_MIN = 0;

export const TARGET_RADIUS_MIN = 100;

export const INTERMEDIATE_TERRAIN_LENGTH_LIMITS = {
  min: MID_TERRAIN_LENGTH_MIN,
  max: MID_TERRAIN_LENGTH_MAX,
};

export const FAR_TERRAIN_LENGTH_LIMITS_BY_RESOLUTION: Record<number, { min: number; max: number }> = {
  30: { min: FAR_TERRAIN_LENGTH_MIN, max: 15000 },
  90: { min: FAR_TERRAIN_LENGTH_MIN, max: 24300 },
  180: { min: FAR_TERRAIN_LENGTH_MIN, max: 38200 },
  270: { min: FAR_TERRAIN_LENGTH_MIN, max: 52100 },
  360: { min: FAR_TERRAIN_LENGTH_MIN, max: 66100 },
  450: { min: FAR_TERRAIN_LENGTH_MIN, max: 80000 },
};

export const getTargetRadiusMax = (lengthMid: number, lengthFar: number) => {
  return Math.max(TARGET_RADIUS_MIN, Number(lengthMid || 0) + Number(lengthFar || 0));
};

export const getFarTerrainLengthMax = (resolution: number) => {
  const safeResolution = Math.min(Math.max(resolution, FAR_TERRAIN_RESOLUTION_MIN), FAR_TERRAIN_RESOLUTION_MAX);
  const ratio =
    (safeResolution - FAR_TERRAIN_RESOLUTION_MIN) / (FAR_TERRAIN_RESOLUTION_MAX - FAR_TERRAIN_RESOLUTION_MIN);
  const rawMaxLength =
    FAR_TERRAIN_LENGTH_MAX_AT_MIN_RESOLUTION +
    ratio * (FAR_TERRAIN_LENGTH_MAX_AT_MAX_RESOLUTION - FAR_TERRAIN_LENGTH_MAX_AT_MIN_RESOLUTION);

  return Math.round(rawMaxLength / 100) * 100;
};
